import React from 'react'
import ReactDOM from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AppProviders } from './context'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const helmetContext = {}

root.render(
  <React.StrictMode>
    <AppProviders>
      <HelmetProvider context={helmetContext}>
        <Helmet>
          <title> بوک استوری - داستان کتاب</title>
          <meta
            name='description'
            content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
          />
        </Helmet>
        <App />
      </HelmetProvider>
    </AppProviders>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
